var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillassessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68895 8.23325C8.68895 9.58719 7.59137 10.6848 6.23743 10.6848C4.8835 10.6848 3.78592 9.58719 3.78592 8.23325C3.78592 6.87932 4.8835 5.78174 6.23743 5.78174C7.59137 5.78174 8.68895 6.87932 8.68895 8.23325Z",
    fill: "#002C3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64502 14.7212C2.64502 12.7371 4.25339 11.1288 6.23742 11.1288C8.22145 11.1288 9.82983 12.7371 9.82983 14.7212V18.6909C9.82983 18.9822 9.59369 19.2183 9.3024 19.2183H3.17245C2.88116 19.2183 2.64502 18.9822 2.64502 18.6909V14.7212Z",
    fill: "#002C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8185 7.70065C11.8185 7.40651 12.0569 7.16805 12.3511 7.16805H21.8224C22.1166 7.16805 22.355 7.40651 22.355 7.70065C22.355 7.9948 22.1166 8.23325 21.8224 8.23325H12.3511C12.0569 8.23325 11.8185 7.9948 11.8185 7.70065Z",
    fill: "#002C3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8185 12.6388C11.8185 12.3446 12.0569 12.1062 12.3511 12.1062H21.8224C22.1166 12.1062 22.355 12.3446 22.355 12.6388C22.355 12.9329 22.1166 13.1714 21.8224 13.1714H12.3511C12.0569 13.1714 11.8185 12.9329 11.8185 12.6388Z",
    fill: "#002C3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8185 17.1154C11.8185 16.8213 12.0569 16.5828 12.3511 16.5828H21.8224C22.1166 16.5828 22.355 16.8213 22.355 17.1154C22.355 17.4096 22.1166 17.648 21.8224 17.648H12.3511C12.0569 17.648 11.8185 17.4096 11.8185 17.1154Z",
    fill: "#002C3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0944 7.78559C21.0944 8.89228 20.1973 9.78943 19.0906 9.78943C17.9839 9.78943 17.0868 8.89228 17.0868 7.78559C17.0868 6.67889 17.9839 5.78174 19.0906 5.78174C20.1973 5.78174 21.0944 6.67889 21.0944 7.78559Z",
    fill: "#002C3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5131 12.6886C17.5131 13.7953 16.6159 14.6925 15.5093 14.6925C14.4026 14.6925 13.5054 13.7953 13.5054 12.6886C13.5054 11.5819 14.4026 10.6848 15.5093 10.6848C16.6159 10.6848 17.5131 11.5819 17.5131 12.6886Z",
    fill: "#002C3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0944 17.2145C21.0944 18.3212 20.1973 19.2183 19.0906 19.2183C17.9839 19.2183 17.0868 18.3212 17.0868 17.2145C17.0868 16.1078 17.9839 15.2106 19.0906 15.2106C20.1973 15.2106 21.0944 16.1078 21.0944 17.2145Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillassessment);
export default __webpack_public_path__ + "static/media/Skill assessment.c8df9aa50c6d6325dabeaaaa8450bb69.svg";
export { ForwardRef as ReactComponent };